import { render, staticRenderFns } from "./other-properties-section.vue?vue&type=template&id=45ce31f3&scoped=true"
import script from "./other-properties-section.vue?vue&type=script&lang=ts"
export * from "./other-properties-section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce31f3",
  null
  
)

export default component.exports